// Business Listing Apis
global.adminAddBusiness = global.API_ADMIN_URL+'adminAddBusiness/';
global.adminEditBusiness = global.API_ADMIN_URL+'adminEditBusiness/';
global.adminBusinessList = global.API_ADMIN_URL+'adminBusinessList/';
global.adminBusinessDelete = global.API_ADMIN_URL+'adminBusinessDelete/';
global.adminBusinessStatus = global.API_ADMIN_URL+'adminBusinessStatus/';
global.adminBusinessDetails = global.API_ADMIN_URL+'adminBusinessDetails/';
global.adminBusinessNameList = global.API_ADMIN_URL+'adminBusinessNameList/';